import React from "react";
import styles from "./distributors-table.module.scss";
import cn from "../../../Utils/class-names.utils";

const getContactBgColor = (bgColor) => {
  const colorMap = {
    "violet": styles.contactBgViolet,
    "orange": styles.contactBgOrange,
    "warning": styles.contactBgWarning,
    "success": styles.contactBgSuccess,
  };
  return colorMap[bgColor] || styles.contactBgDefault;
};

export const DistributorsTableRow = ({ data, isAlternate, onRowClick }) => {
  const contactBgClass = getContactBgColor(data.contact.bgColor);
  const companyBgClass = getContactBgColor(data.company.bgColor);

  const handleClick = (e) => {
    // Don't trigger navigation if clicking on dropdown, button, or links
    if (
      e.target.closest('[role="menu"]') || 
      e.target.closest('.dropdown') || 
      e.target.closest('button') ||
      e.target.closest('a')
    ) {
      return;
    }

    if (onRowClick && data.id) {
      onRowClick(data.id);
    }
  };

  return (
    <tr className={styles.tableRow} onClick={handleClick}>
      <td className={styles.tableCell}>
        <div className={styles.companyCell}>
          <div className={cn(styles.companyInitial, companyBgClass)}>
            {data.company.initial}
          </div>
          <div className={styles.companyName}>{data.company.name}</div>
        </div>
      </td>

      <td className={styles.tableCell}>
        <div className={styles.countryCell}>{data.country}</div>
      </td>

      <td className={styles.tableCell}>
        <div className={styles.contactCell}>
          <div className={cn(styles.contactInitial, contactBgClass)}>
            {data.contact.initial}
          </div>
          <div className={styles.contactInfo}>
            <div className={styles.contactName}>{data.contact.name}</div>
            <div className={styles.contactEmail}>{data.contact.email}</div>
          </div>
        </div>
      </td>

      <td className={styles.tableCell}>
        <time className={styles.dateCell}>{data.createdDate}</time>
      </td>

      <td className={styles.tableCell}>
        <time className={styles.dateCell}>{data.lastActivity}</time>
      </td>

      <td className={styles.tableCell}>
        <div className={styles.numberCell}>{data.contacts}</div>
      </td>

      <td className={styles.tableCell}>
        <div className={styles.numberCell}>{data.deals}</div>
      </td>

      <td className={styles.tableCell}>
        <div className={styles.numberCell}>{data.revenue}</div>
      </td>
    </tr>
  );
};